<template>
    <infinite-scroller-vertical @scrolledTillBottom="reachedBottom" :windowTarget="false">
        <v-list>
            <user-list-item v-for="follower in followers" :key="follower.id" :userDetail="follower"></user-list-item>
            <template v-if="followingLoading">
                <v-skeleton-loader type="list-item-avatar-two-line" v-for="n in 3" :key="'skeleton-follower-loader-' + n"></v-skeleton-loader>
            </template>
        </v-list>
    </infinite-scroller-vertical>
</template>
<script>
import {
    GET_FOLLOWING_LIST
} from "@/store/actions.type"
import {
    CLEAR_PROFILE_FOLLOWING
} from "@/store/mutations.type"
import userListItem from "@/components/list-item/list-item-user.vue"
export default {
    components: {
        'user-list-item': userListItem
    },

    props: {
        userId: String
    },

    data: () => ({
        followingLoading: false,
    }),

    computed: {
        followers() {
            return this.$store.state.profile.profileFollowing
        }
    },

    created() {
        this.fetchFollowing()
    },

    methods: {
        fetchFollowing() {
            if (!this.followingLoading && !this.$store.state.profile.profileFollowingFetchCompleted) {
                this.followingLoading = true
                this.$store.dispatch(GET_FOLLOWING_LIST, {
                        userId: this.userId
                    })
                    .then(() => {
                        this.followingLoading = false
                    })
                    .catch(() => {
                        this.followingLoading = false
                    })
            }

        },

        reachedBottom(val) {
            if (val) {
                this.fetchFollowing()
            }
        }
    },

    destroyed() {
        this.$store.commit(CLEAR_PROFILE_FOLLOWING)
    }
}
</script>